export const chart_theme_blue_ColorScale_200 = {
  "name": "--pf-chart-theme--blue--ColorScale--200",
  "value": "#8bc1f7",
  "var": "var(--pf-chart-theme--blue--ColorScale--200, #8bc1f7)"
};
export default chart_theme_blue_ColorScale_200;